import {
  getMiddleCenterBias,
  GridCellKind,
  type DrawCellCallback,
  type SizedGridColumn,
} from "@glideapps/glide-data-grid";
import type { TextOverflowSpan } from "./adapter";

interface DrawTextOverflowCellOptions {
  args: Parameters<DrawCellCallback>[0];
  columns: SizedGridColumn[];
  drawContent: Parameters<DrawCellCallback>[1];
  textOverflow: TextOverflowSpan | undefined;
}

const getColumnOffset = (
  columns: SizedGridColumn[],
  sourceCol: number,
  targetCol: number,
) =>
  columns
    .slice(sourceCol, targetCol)
    .reduce((total, column) => total + column.width, 0);

export const drawTextOverflowCell = ({
  args,
  columns,
  drawContent,
  textOverflow,
}: DrawTextOverflowCellOptions) => {
  drawContent();

  if (
    args.cell.kind !== GridCellKind.Text ||
    !textOverflow ||
    textOverflow.sourceCol === args.col
  ) {
    return;
  }

  const sourceOffset = getColumnOffset(
    columns,
    textOverflow.sourceCol,
    args.col,
  );
  const baseFontStyle =
    textOverflow.themeOverride?.baseFontStyle ?? args.theme.baseFontStyle;
  const font = `${baseFontStyle} ${args.theme.fontFamily}`;

  args.ctx.save();
  args.ctx.beginPath();
  args.ctx.rect(args.rect.x, args.rect.y, args.rect.width, args.rect.height);
  args.ctx.clip();
  args.ctx.font = font;
  args.ctx.fillStyle =
    textOverflow.themeOverride?.textDark ?? args.theme.textDark;
  args.ctx.textBaseline = "middle";
  args.ctx.fillText(
    textOverflow.displayData,
    args.rect.x - sourceOffset + args.theme.cellHorizontalPadding + 0.5,
    args.rect.y + args.rect.height / 2 + getMiddleCenterBias(args.ctx, font),
  );
  args.ctx.restore();
};
